import * as React from "react";
import { MyAccountService } from "./myaccount-service";
import { Props } from "../../types/global";
import { Loading } from "../common/Loading";
import AutoProfileBlock from "./AutoProfileBlock";
import { AutoProfile } from "../types";
import { Footer } from "./Footer";
import t from "../i18n";
import { AuthService } from "../auth/auth-service";
import Img from "../Controls/Img";
declare type AutoTopupsState = {
    profiles?: AutoProfile[],
    showInstructions: boolean;
}
export class AutoTopups extends React.Component<Props, AutoTopupsState> {
    readonly state: AutoTopupsState = { showInstructions: false };
    async componentDidMount() {
        const userName = await AuthService.isLoggedIn();
        if (!userName) {
            this.setState({ showInstructions: true });
            return;
        }
        const response = await MyAccountService.fetchRecurringProfileList();
        if (!response || !response.payLoad) {
            this.props.history.push("/topup");
            return;
        }
        this.setState({ profiles: response.payLoad || [] });
    }
    createNew = () => {
        this.props.history.push("/auto-topup");
    }
    renderEmpty() {
        return <div className="container-fluid small-gutter" style={pageWidth}>
            <div className="form-group form-title">
                <h2>{t.autoTopup("auto_balance_header")}</h2>
            </div>
            <div className="row">
                <div className="col-12">
                    <div>{t.autoTopup("no_profile_msg")}</div>
                </div>
            </div>
            <Footer buttonText={t.autoTopup("new_profile_button_title")} onButtonClick={this.createNew} />
        </div>
    }
    renderInstructions() {
        return <div className="container-fluid small-gutter" style={pageWidth}>
            <div className="form-group form-title">
                <h2>{t.autoTopup("auto_balance_header")}</h2>
            </div>
            <div className="row">
                <div className="col-12 text-center">
                    <div><Img style={{width:260}} src="/images/mobile/gtt-auto-profile.png"/></div>
                </div>
            </div>
            <Footer buttonText={t.autoTopup("new_profile_button_title")} onButtonClick={this.createNew} />
        </div>
    }
    render() {
        if (this.state.showInstructions) return this.renderInstructions();
        if (!this.state.profiles) return <Loading />;
        if (this.state.profiles.length === 0) {
            return this.renderEmpty();
        }
        return <div className="container-fluid small-gutter" style={pageWidth}>
            <div className="form-group form-title">
                <h2>{t.autoTopup("auto_balance_header")}</h2>
            </div>
            <div className="row">
                {this.state.profiles.map(p => <AutoProfileBlock key={p.recurringProfileId} profile={p} />)}
            </div>
            <Footer buttonText={t.autoTopup("new_profile_button_title")} onButtonClick={this.createNew} />
        </div>
    }
}
const pageWidth: React.CSSProperties = {
    maxWidth: 768,
    width: "100%",
}
